import { useSelectContext } from '../../Select.hooks'
import { SelectEntityItemAvatar } from '../../SelectEntityItemAvatar'
import { SelectDropdownEntityListItemContentContainer } from '../SelectDropdownEntityListItemContentContainer'
import { SelectDropdownEntityListItemContentInfo } from '../SelectDropdownEntityListItemContentInfo'
import { SelectDropdownEntityListItemIcons } from '../SelectDropdownEntityListItemIcons'

import { getSelectDropdownEntityListItemIconProps } from './SelectDropdownEntityListItemContent.utils'

function SelectDropdownEntityListItemContent({
  Avatar = SelectEntityItemAvatar,
  Icons = SelectDropdownEntityListItemIcons,
  Info = SelectDropdownEntityListItemContentInfo,
  avatarProps,
  disabled,
  infoProps,
  isFocused,
  isHovered,
  isIconFollowingHover,
  isSelected,
  style,
  value,
}) {
  const { Icon, avatar, isArchived } = value

  const { EntityIcon, multi } = useSelectContext()

  return (
    <SelectDropdownEntityListItemContentContainer
      isHovered={isHovered}
      isSelected={isSelected}
      multi={multi}
      style={style}
    >
      {Avatar && (avatar || EntityIcon || Icon) ? (
        <Avatar
          {...avatarProps}
          Icon={EntityIcon || Icon}
          avatar={avatar}
          iconProps={getSelectDropdownEntityListItemIconProps({
            iconProps: avatarProps?.iconProps,
            isActive: isFocused || isHovered || isSelected,
            isIconFollowingHover,
          })}
        />
      ) : null}
      {Info ? (
        <Info
          {...infoProps}
          disabled={disabled}
          isActive={isSelected}
          isFocused={isFocused}
          isHovered={isHovered}
          value={value}
        />
      ) : null}
      {Icons ? (
        <Icons
          isArchived={isArchived}
          isSelected={isSelected && !multi}
          value={value}
        />
      ) : null}
    </SelectDropdownEntityListItemContentContainer>
  )
}

export default SelectDropdownEntityListItemContent
